import React, { lazy, Suspense } from 'react'
import { Switch, Route, useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import Auth from '../../../../Layout/Auth'
import RequisitionList from '../Pages/RequisitionList'
import WorkInProgress from '../../../../GlobalModules/Utility/Components/WorkInProgress'
const AddRequisition = lazy(() => import('../Pages/AddRequisition'))
const RequisitionView = lazy(() => import('../Pages/RequisitionView'))
const EditRequisition = lazy(() => import('../Pages/EditRequisition'))

function RequisitionRoute() {
  const history = useHistory()
  return (
    <Switch>
      <Route
        exact
        path='/:lng/sales/requisitions'
        render={() => (
          <Auth
            history={history}
            allowedRoles={['app_admin', 'admin', 'staff']}
          >
            <RequisitionList history={history} />
          </Auth>
        )}
      />
      <Route
        exact
        path='/:lng/sales/requisitions/add'
        render={() => (
          <Auth
            history={history}
            allowedRoles={['app_admin', 'admin', 'staff']}
          >
            <Suspense
              fallback={
                <div className='wrapper'>
                  <span>Loading</span>
                </div>
              }
            >
              <AddRequisition />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path='/:lng/sales/requisitions/view/:slack'
        render={(props) => (
          <Auth
            history={history}
            allowedRoles={['app_admin', 'admin', 'staff']}
          >
            <Suspense
              fallback={
                <div className='wrapper'>
                  <span>Loading</span>
                </div>
              }
            >
              <RequisitionView {...props} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path='/:lng/sales/requisitions/edit/:slack'
        render={(props) => (
          <Auth
            history={history}
            allowedRoles={['app_admin', 'admin', 'staff']}
          >
            <Suspense
              fallback={
                <div className='wrapper'>
                  <span>Loading</span>
                </div>
              }
            >
              <EditRequisition {...props} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path='/:lng/sales/requisitions/list'
        render={() => <WorkInProgress />}
      />
      <Route
        path='/:lng/sales/requisitions/:unknown'
        render={() => <WorkInProgress />}
      />
    </Switch>
  )
}

const mapStateToProps = (globalState) => ({
  userCredentials: globalState.LoginReducer.userCredentials,
  userEntryType: globalState.LoginReducer.userEntryType
})

export default connect(mapStateToProps)(RequisitionRoute)
